import { ReactComponent as Logout } from '@assets/svg/sign-out-alt-solid.svg';
import { ReactComponent as LoginLogo } from '@assets/svg/user-circle-solid.svg';
import { ProjectResetPaginationAction } from '@features/project/state/actions';
import { ServiceResetExecutionPaginationAction, ServiceResetPaginationAction } from '@features/service/store/actions';
import { StoreManager } from '@hypereact/state';
import { TranslatorManager } from '@managers/TranslatorManager';
import { NavigationManager } from '@managers/navigation.manager';
import KeycloakUtil from '@utils/keycloak.util';
import './styles/login.header.styles.scss';

export interface LoginHeaderProps {}

const LoginHeader: React.FC<LoginHeaderProps> = () => {
    const translator = TranslatorManager.getInstance();
    const storeManager = StoreManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const isLogged: boolean = KeycloakUtil.isLoggedIn();

    const handleLogout = () => {
        storeManager.dispatch(new ProjectResetPaginationAction());
        storeManager.dispatch(new ServiceResetPaginationAction());
        storeManager.dispatch(new ServiceResetExecutionPaginationAction());
        KeycloakUtil.handleLogout();
    };

    let isHome = navigationManager.getCurrentRoute().includes('/home');

    return (
        <div className={isHome ? 'home-login-container' : 'login-container'}>
            {isLogged ? (
                <div className='login-link-container'>
                    <a className='d-flex align-items-center log-in-out-text logout-cursor'>
                        <span className={isHome ? 'home-logout-text-container' : 'logout-text-container'}>{KeycloakUtil.getName()}</span>
                        <div onClick={handleLogout}>
                            <Logout className='ms-2' fill={isHome ? '#009138' : 'white'} width={15} />
                        </div>
                    </a>
                </div>
            ) : (
                <div className='login-link-container'>
                    <a className='log-in-out-text' onClick={KeycloakUtil.handleLogin}>
                        <span className={isHome ? 'home-login-text-container' : 'login-text-container'}>{translator.get('login.button.text')}</span>
                        <LoginLogo className='login-icon ms-2' fill={isHome ? '#009138' : 'white'} />
                    </a>
                </div>
            )}
        </div>
    );
};

export default LoginHeader;
